import React, { useContext, useEffect, useState } from "react";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import { Button, Card, Skeleton } from "antd";
import CustomHeader from "../common/Header";
import { Masonry } from "@mui/lab";
import CustomTable from "../common/Table";
import { SettingContext } from "../../routes";
import { useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import moment from "moment";

const ReceiptDetails = () => {
    const { selectedDates } = useContext(SettingContext);
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [start_date, end_date] = selectedDates;
    const [tableData, setTableData] = useState([]);
    const { receipt_is_for, hotel_id } = useParams();
    const {
        state: { receipt_sent_via, transaction_via },
    } = useLocation();
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids: [hotel_id],
        receipt_is_for,
        receipt_sent_via,
        transaction_via,
        sorting: 1,
        sort_by: "",
    });

    const getDynamicColumn = () => {
        let column = [
            {
                title: "Transaction ID",
                dataIndex: "operation_id",
                key: "operation_id",
                render: (record) => {
                    if (record) {
                        return <>{record}</>;
                    } else {
                        return <>-</>;
                    }
                },
            },
            {
                title: `Date of ${receipt_sent_via === 1 ? "Email" : "Print"}`,
                dataIndex: "updated_at",
                key: "updated_at",
                render: (record) => {
                    return <>{moment(record).format("YYYY/MM/DD HH:MM:SS")}</>;
                },
            },
            {
                title: "Staff Name ",
                dataIndex: "staff_name",
                key: "staff_name",
                render: (record) => (record ? <>{record}</> : <>-</>),
            },
        ];
        return column;
    };

    const {
        status: receiptDetailsResStatus,
        data: receiptDetailsRes,
        refetch: fetchReceiptsDetails,
    } = useQuery(
        `receipts${hotel_id}`,
        async () => {
            return await HTTP(
                "/dashboard/getDashboardReceiptsWiseCountsDetailsForHotel",
                {
                    ...formData,
                },
            );
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchReceiptsDetails();
    }, []);

    useEffect(() => {
        fetchReceiptsDetails();
    }, [formData]);

    useEffect(() => {
        if (receiptDetailsResStatus === "success") {
            const { data: receiptData, total } = receiptDetailsRes;
            setTotalRecords(total);
            setTableData(receiptData);
        }
    }, [receiptDetailsResStatus, receiptDetailsRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        setFormData({
            ...formData,
            page: current - 1,
            limit: pageSize,
        });
        setCurrentPage(current);
    }

    async function downalodReport() {
        const tempFormData = { ...formData };
        const res = await HTTP(
            "/dashboard/getDashboardReceiptsWiseCountsDetailsForHotelReport",
            {
                ...tempFormData,
            },
        );
        downloadCSV(res, `Sent_receipt_details_report`);
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Masonry columns={1} spacing={1}>
                <Card className="box-shadow margin-10">
                    {receiptDetailsResStatus === "loading" ||
                    receiptDetailsResStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={getDynamicColumn()}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            currentPage={currentPage}
                            handleTableChange={handleTableChange}
                            rowKey="receipt-id"
                        />
                    )}
                </Card>
            </Masonry>
        </Card>
    );
};

export default ReceiptDetails;
